import { ConfigApi, useApi, configApiRef } from '@backstage/core-plugin-api';
import { useIdentity } from '@internal/shared';

export function useApiEssentials(path?: string): {
  apiUrl: string;
  isSignedIn: boolean;
  getIdToken: () => Promise<string>;
} {
  const configApi: ConfigApi = useApi(configApiRef);
  const baseUrl = configApi.getString('dxmGateway.url');
  const backendPath = configApi.getString('userManagement.backendPath');
  const { idToken, getIdToken } = useIdentity();
  const apiUrl = `${baseUrl}${path ?? backendPath}`;

  return {
    apiUrl,
    isSignedIn: !!idToken,
    getIdToken,
  };
}
